module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Thunder-night-969293753ce5a12143e8db68c4db376e.svg";